module.exports = __webpack_public_path__ + "static/media/026.5453d742.jpg";